import React from "react";
import { useFormContext } from "react-hook-form";

import PropertyTypesIconMapping from "../../../../assets/icons/PropertyTypesIconMapping";
import CustomSvg from "../../../../shared/components/custom-svg/CustomSvg";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";

const PropetyTypePreference = ({ allPropertyTypes }) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div>
      <div className="question-heading">
        Where would you like to live?
        <div>
          <span>Select below.</span>
        </div>
      </div>
      {errors.preferredLocationIds && (
        <div className="error">{errors.preferredLocationIds.message}</div>
      )}
      <div className="form-fields">
        {allPropertyTypes.map((type) => (
          <SurveyFormField
            name="preferredLocationIds"
            multiple
            key={type.id}
            variant="radio"
            label={type.title}
            value={type.id}
            endAdornment={
              <div className="position-absolute marks-adornment">
                <CustomSvg
                  color="#fff"
                  src={PropertyTypesIconMapping[type.icon]}
                  className="survey-property-type-preference-icon"
                />
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default PropetyTypePreference;
